import moment from "moment";
import React, { useMemo } from "react";
import { useHistory } from "react-router";
import { Card, CardBody } from "reactstrap";

import { formattedPrice } from "views/pages/manage/unAssigned/collectPayment/utils";
import ServerDataGrid from "views/pages/manage/common/data-grid/ServerDataGrid";
import { getFormattedTime } from "../../../common/utils/methods/commonMethods/utilityMethod";

const ExamPayRateTable = ({ vendorDetails, totalAmount }) => {
  const rows = vendorDetails?.vendorTestMappingList || [];
  const stream = vendorDetails?.academicGroupDispValue;
  const history = useHistory();

  const columns = useMemo(
    () => [
      {
        key: "testName",
        label: "TEST ID",
        width: 120,
        sortable: true,
        render: (value) => value || "-",
      },
      {
        key: "testDesc",
        label: "Desc",
        width: 150,
        sortable: true,
        render: (value) => value || "-",
      },
      {
        key: "academicGroupDispValue",
        label: "Stream",
        width: 120,
        sortable: true,
        render: (value) => value || "-",
      },
      {
        key: "termDispValue",
        label: "Term",
        width: 120,
        sortable: true,
        render: (value) => value || "-",
      },
      {
        key: "examDate",
        label: "Exam Date",
        width: 120,
        sortable: true,
        render: (value) => (value ? moment(value).format("DD/MM/YYYY") : "-"),
      },
      {
        key: "startTime",
        label: "Test Timing",
        width: 120,
        sortable: false,
        render: (value) => (value ? getFormattedTime(value) : "-"),
      },
      {
        key: "roomDispValue",
        label: "Room No.",
        width: 120,
        sortable: true,
        render: (value) => value || "-",
      },
      {
        key: "endTime",
        label: "No. of Hours",
        width: 130,
        sortable: true,
        render: (value, row) => {
          const start = moment(row.startTime);
          const end = moment(value);

          const hours = end.diff(start, "hours");

          if (hours >= 1) {
            return `${hours} hour${hours > 1 ? "s" : ""}`;
          } else {
            const minutes = end.diff(start, "minutes");
            return `${minutes} minute${minutes > 1 ? "s" : ""}`;
          }
        },
      },
      {
        key: "amount",
        label: "Payment Amount",
        width: 140,
        sortable: true,
        pinned: true,
        render: (value) =>
          value ? (
            <span className="text-success">{formattedPrice(value)}</span>
          ) : (
            "-"
          ),
      },
      {
        key: "costCenter",
        label: "Cost Centre",
        width: 140,
        pinned: true,
        sortable: true,
        render: (value) => value || "-",
      },
    ],
    [history],
  );

  return (
    <Card className="mb-3">
      <CardBody className="px-4 py-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="text-bold">Exam & Pay Hours - {stream || "-"}</div>
          <div className="text-bold text-success">
            Total Amount: {formattedPrice(totalAmount)}
          </div>
        </div>

        <ServerDataGrid
          rows={rows}
          columns={columns}
          rowId={(row) => `${row.testName} ${row?.id}`}
          height="400px"
          pagination={{
            page: 1,
            pageSize: 200,
            total: rows.length,
            totalPages: 1,
          }}
        />
      </CardBody>
    </Card>
  );
};

export default ExamPayRateTable;
